import { render, staticRenderFns } from "./Recommendation.vue?vue&type=template&id=688f082b"
import script from "./Recommendation.vue?vue&type=script&lang=ts"
export * from "./Recommendation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports